"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var rsvp_1 = require("../types/enums/rsvp");
exports.getAvatars = function (members, totalGuests, isRsvp, maxAvatars) {
    var memberAvatars = getMemberAvatars(members, isRsvp);
    return __spreadArrays(memberAvatars, getAnonymousAvatars(totalGuests, maxAvatars, memberAvatars.length));
};
var getMemberAvatars = function (members, isRsvp) {
    if (isRsvp) {
        members = members.filter(function (member) { return member.rsvpStatus === rsvp_1.RsvpStatus.YES; });
    }
    return members.map(function (member) { return ({
        name: member.nickname,
        src: member.imageUrl
    }); });
};
var getAnonymousAvatars = function (totalGuests, maxAvatars, memberCount) {
    var total = getTotalAttendingGuests(totalGuests);
    var neededAvatarCount = Math.min(maxAvatars, total);
    var anonymousAvatars = [];
    while (anonymousAvatars.length < neededAvatarCount - memberCount) {
        anonymousAvatars.push({});
    }
    return anonymousAvatars;
};
exports.getExtraGuestsCount = function (totalGuests, maxAvatars) {
    var total = getTotalAttendingGuests(totalGuests) - maxAvatars;
    return total > 0 ? total : 0;
};
var getTotalAttendingGuests = function (totalGuests) {
    return typeof totalGuests === 'number' ? totalGuests : totalGuests.YES || 0;
};
